'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonelinkErase = function MdPhonelinkErase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 1.6c1.8 0 3.4 1.6 3.4 3.4v30c0 1.8-1.6 3.4-3.4 3.4h-16.6c-1.8 0-3.4-1.6-3.4-3.4v-5h3.4v3.4h16.6v-26.8h-16.6v3.4h-3.4v-5c0-1.8 1.6-3.4 3.4-3.4h16.6z m-10 12.1l-6.6 6.6 6.6 6.7-1.6 1.7-6.6-6.7-6.8 6.7-1.6-1.7 6.6-6.7-6.6-6.6 1.6-1.7 6.8 6.7 6.6-6.7z' })
        )
    );
};

exports.default = MdPhonelinkErase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phonelink-erase.js
// module id = 2644
// module chunks = 0